"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardTossAbilityHandler = exports.CardTossActorAbilityFactory = exports.CardTossAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Damage_1 = require("../../core/Damage");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class CardTossAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.CardToss;
        this.__typeName = "CardToss";
    }
}
exports.CardTossAbilityArgs = CardTossAbilityArgs;
let CardTossActorAbilityFactory = class CardTossActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("CardToss", "OneEnemies", 0);
    }
};
CardTossActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("CardToss")
], CardTossActorAbilityFactory);
exports.CardTossActorAbilityFactory = CardTossActorAbilityFactory;
let CardTossAbilityHandler = class CardTossAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedEnemy] = ability.args.target.actorIds;
        container.applyProjectileAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            attackerId: ability.invokerId,
            targetId: selectedEnemy,
            projectileType: "GreenCard",
            projectilePath: "line",
            toApply: [
                AbilityDamage_1.AbilityDamage.Focus("Chaos", 40)
            ],
            onHit(sequence, _attack, damages) {
                const total = Damage_1.Damage.Sum(damages);
                for (const allyId of container.selectLivingTargets(ability.invokerId, Target_1.Target.AllAllies)) {
                    container.applyHealing({
                        sequence,
                        healerId: ability.invokerId,
                        targetId: allyId,
                        amount: Math.round(.25 * total),
                        onApplied: sequence => {
                            if (container.hasAttribute(ability.invokerId, "Charm_Gambler_1")
                                && container.testAttribute(ability.invokerId, "Luck", 25)) {
                                container.removeDebuffs({
                                    sequence,
                                    removerId: ability.invokerId,
                                    targets: [{
                                            targetId: allyId,
                                            includeSupernatural: false
                                        }]
                                });
                            }
                        }
                    });
                }
            }
        });
    }
};
CardTossAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.CardToss)
], CardTossAbilityHandler);
exports.CardTossAbilityHandler = CardTossAbilityHandler;
